import { render, staticRenderFns } from "./main-block.vue?vue&type=template&id=92adaa8c"
import script from "./main-block.vue?vue&type=script&lang=js"
export * from "./main-block.vue?vue&type=script&lang=js"
import style0 from "./main-block.vue?vue&type=style&index=0&id=92adaa8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports